import { RouteObject } from "react-router-dom"



import Profile from "@/features/settings/pages/profile"
import Identification from "@/features/settings/pages/identification"
import SettingsLayout from "@/features/settings/pages/settings-layout"
import BusinessDetails from "@/features/settings/pages/business-details"
import NotificationDetails from "@/features/settings/pages/notification"



const routes: RouteObject = {
    path: "/settings/",
    element: <SettingsLayout />,
    children: [
        {
            index: true,
            element: <Profile />
        },
        {
            path: "identification",
            element: <Identification />
        },
        {
            path: "business",
            element: <BusinessDetails />
        },
        {
            path: "notification",
            element: <NotificationDetails />
        }
    ]
  
}

export default routes
